import { render, staticRenderFns } from "./OurWarningChips.vue?vue&type=template&id=83f2b94a&"
import script from "./OurWarningChips.vue?vue&type=script&lang=js&"
export * from "./OurWarningChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports